/*
 * Copyright (c) 2021 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	GreenlightTextTools_ParagraphHighlight.js
 *
 * Description:	The class containing the functionality required by the Greenlight for text tools for a paragraph highlight.
 * 
 */

// The text tools object.
var g_oTextTools_ParagraphHighlight = {};

(function () {
	"use strict";

	/**
	 * Load the paragraph highlight tool for the page.
	 */
	function TextTools_ParagraphHighlight() {};

	/**
	 * Initialises the paragraph highlight.
	 */
	TextTools_ParagraphHighlight.prototype.initialiseHighlight = function () {

		// Determine the canvas to highlight on, and the non highlight canvas.
		var oViewer = !g_oTextTools.g_bHighlightOnCompareCanvas ? g_oViewer.g_oArtworkViewer : g_oCompare.g_oCompareViewer;
		var oAnnotationViewer = !g_oTextTools.g_bHighlightOnCompareCanvas ? g_oViewer.g_oAnnotationViewer : g_oCompare.g_oCompareAnnotationViewer;
		var szHighlightCanvas = !g_oTextTools.g_bHighlightOnCompareCanvas ? "AnnotationViewer" : "CompareAnnotationViewer";
		var szNonHighlightCanvas = !g_oTextTools.g_bHighlightOnCompareCanvas ? "CompareAnnotationViewer" : "AnnotationViewer";

		// Reset the highlighting to the existing sections.
		g_oTextTools.removeHighlights(oAnnotationViewer);
		g_oTextTools.highlightSections(g_oTextTools.g_oAnnotationText, oViewer, oAnnotationViewer);

		// Activate the mouse move event.
		changeCanvasFunction($("#" + szHighlightCanvas), 'pointermove.annotationUI', function (event) {
			g_oTextTools_ParagraphHighlight.mouseMove(event, oViewer, oAnnotationViewer);
		});

		// Activate the mouse down event.
		changeCanvasFunction($("#" + szHighlightCanvas), 'pointerdown', function (event) {
			g_oTextTools_ParagraphHighlight.mouseDown(event, oViewer, oAnnotationViewer);
		});

		// Activate the mouse down event for the compare canvas.
		$("#" + szNonHighlightCanvas).css("cursor", "default");
		changeCanvasFunction($("#" + szNonHighlightCanvas), 'pointerdown', function (event) {
			g_oGreenlightMessages.displayWarningBubble(g_oTextTools.c_szHighlightUnavailableCanvas);
		});
	};

	/**
	 * Mouse move event for the paragraph highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_ParagraphHighlight.prototype.mouseMove = function (event, oArtworkCanvas, oAnnotationCanvas) {

		// Get the text data for the document page.
		var oTextData = g_oTextData.getTextData(oArtworkCanvas.g_oDoc.documentId, oArtworkCanvas.g_iCurrentPage).textData;

		// Get the position of the mouse.
		var oPosition = g_oTextTools.convertMousePositionToPercentages(event, oArtworkCanvas, oAnnotationCanvas);

		// Try to find a paragragh.
		var iParagraph = g_oTextTools.findParagraph(oPosition.x, oPosition.y, oTextData);

		// Determine the canvas id.
		var szCanvasId = "#" + (!g_oTextTools.g_bHighlightOnCompareCanvas ? "AnnotationViewer" : "CompareAnnotationViewer");

		// Change the cursor based on if a word was found.
		$(szCanvasId).css("cursor", g_oTextTools.g_oCurrentText == null ? "default" : "text");

		// If we have no paragraph, highlight only the existing sections.
		if (iParagraph == -1) {
			g_oTextTools.removeHighlights(oAnnotationCanvas);
			g_oTextTools.highlightSections(g_oTextTools.g_oAnnotationText, oArtworkCanvas, oAnnotationCanvas);
			return;
		}

		// Highlight the existing sections and new paragraph.
		g_oTextTools.removeHighlights(oAnnotationCanvas);
		g_oTextTools.highlightSections(g_oTextTools.g_oAnnotationText.concat([{ startingText: g_oTextTools.getFirstTextInParagraph(iParagraph, oArtworkCanvas, oAnnotationCanvas), endingText: g_oTextTools.getLastTextInParagraph(iParagraph, oArtworkCanvas, oAnnotationCanvas), leftToRight: g_oTextTools.isTextHighlightLeftToRight() }]), oArtworkCanvas, oAnnotationCanvas);
	};

	/**
	 * Mouse down event for the paragraph highlight.
	 * @param {object} event - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	TextTools_ParagraphHighlight.prototype.mouseDown = function (event, oArtworkCanvas, oAnnotationCanvas) {

		// Get the text data for the document page.
		var oTextData = g_oTextData.getTextData(oArtworkCanvas.g_oDoc.documentId, oArtworkCanvas.g_iCurrentPage).textData;

		// Get the position of the mouse.
		var oPosition = g_oTextTools.convertMousePositionToPercentages(event, oArtworkCanvas, oAnnotationCanvas);

		// Try to find a paragragh.
		var iParagraph = g_oTextTools.findParagraph(oPosition.x, oPosition.y, oTextData);

		// Ensure we have moused down on text.
		if (iParagraph == -1) {
			g_oGreenlightMessages.displayWarningBubble(g_oTextTools.c_szNoLiveTextFound);
			return;
		}
		
		// Add the section to the annotation text.
		g_oTextTools.g_oAnnotationText.push({ startingText: g_oTextTools.getFirstTextInParagraph(iParagraph, oArtworkCanvas, oAnnotationCanvas), endingText: g_oTextTools.getLastTextInParagraph(iParagraph, oArtworkCanvas, oAnnotationCanvas), leftToRight: g_oTextTools.isTextHighlightLeftToRight() });

		// If this is an existing annotation, re-initialise the tool.
		if (g_oTextTools.g_iExistingAnnotationId != null) {
			g_oTextTools.initialiseTextTool(g_oTextTools.g_eToolTypes.ParagraphHighlight, g_oTextTools.g_eActiveAnnotationType, g_oTextTools.g_bHighlightIsCharacterAccuracy, g_oTextTools.g_bHighlightOnCompareCanvas, g_oTextTools.g_szHighlightColour);
			return;
		}

		// End the highlight.
		g_oTextTools.endhighlight(oArtworkCanvas, oAnnotationCanvas, true);
	};

	// Add the Text Tools tool object to the window.
	window.TextTools_ParagraphHighlight = TextTools_ParagraphHighlight;
}());